export default "__VITE_ASSET__BKrxQ6ND__"